import React, {useEffect, useState} from 'react';
import {qrCodeDataUrl} from './send-qr-utils';

interface SendQrDisplayProps {
  url: string;
  size?: number;
  className?: string;
}

export function SendQrDisplay({url, size = 220, className}: SendQrDisplayProps) {
  const [dataUrl, setDataUrl] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!url) {
      setDataUrl('');
      setFailed(false);
      return;
    }

    let cancelled = false;
    setFailed(false);
    qrCodeDataUrl(url, size)
      .then(result => {
        if (!cancelled) setDataUrl(result);
      })
      .catch(() => {
        if (!cancelled) {
          setDataUrl('');
          setFailed(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [url, size]);

  if (failed) {
    return (
      <div className={className}>
        <p className="text-center text-[14px] text-[#E34444]">Could not render QR code.</p>
      </div>
    );
  }

  if (!dataUrl) {
    return (
      <div className={className}>
        <p className="text-center text-[14px] text-muted">Generating QR…</p>
      </div>
    );
  }

  return (
    <img
      src={dataUrl}
      alt="QR code for receive link"
      className={className}
      width={size}
      height={size}
    />
  );
}
